import React from 'react'

type SeparateMapLayoutProps = {
  children: React.ReactNode
}

const SeparateMapLayout = ({ children }: SeparateMapLayoutProps) => {
  React.useEffect(() => {
    const bc = new BroadcastChannel('theme-channel')

    const updateTheme = (theme: string) => {
      document.documentElement.classList.remove('dark', 'light')
      document.documentElement.classList.add(theme)
    }

    const handleMessage = (event: MessageEvent) => {
      const { type, payload } = event.data || {}
      if (type === 'THEME_CHANGE') updateTheme(payload)
    }

    bc.addEventListener('message', handleMessage)

    updateTheme(localStorage.getItem('theme') || 'light')

    return () => {
      bc.removeEventListener('message', handleMessage)
      bc.close()
    }
  }, [])

  return <div className='min-h-screen bg-crane-background text-crane-foreground'>{children}</div>
}

export default SeparateMapLayout
